import {ENDPOINTS} from '~/constants';
import {ThunkApi} from '~/utils/thunk-api';
import {DeleteParams, FetchParams, PostParams, PutParams} from '~/utils/thunk-api/type';
import {AdminEntity, NormalizedAdmin} from '~/redux/admins/types';
import {adminSchema} from '~/redux/admins/entity-config';

export interface FetchUserInfoParams extends FetchParams {}

export interface FetchAdminsParams extends FetchParams {}

export interface AddAdminParams extends PostParams {
  data: Partial<AdminEntity>;
}

export interface UpdateAdminParams extends PutParams {
  data: Partial<AdminEntity>;
  id: number;
}

const thunk = new ThunkApi<AdminEntity, NormalizedAdmin>('admin', adminSchema);
export const fetchAdmins = thunk.fetch<FetchAdminsParams>(ENDPOINTS.ADMINS);
export const addAdmin = thunk.post<AddAdminParams>(ENDPOINTS.ADMINS);
export const updateAdmin = thunk.put<UpdateAdminParams>(`${ENDPOINTS.ADMINS}/:id`);
export const deleteAdmin = thunk.delete<DeleteParams>(`${ENDPOINTS.ADMINS}/:id`);

export const fetchCurrentUserInfo = thunk.fetchOne<FetchUserInfoParams>(ENDPOINTS.CURRENT_USER, 'me/detail', {
  includeApiResponseData: true,
});
